import { render, staticRenderFns } from "./PFIndividualSettlementReport.vue?vue&type=template&id=bec011d0"
import script from "./PFIndividualSettlementReport.vue?vue&type=script&lang=js"
export * from "./PFIndividualSettlementReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports